module.exports = "<ngx-loading [show]=\"show\"></ngx-loading>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/_utils/templates/spinner/spinner.component.html
// module id = ./src/app/shared/_utils/templates/spinner/spinner.component.html
// module chunks = main